import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import getErrorForToast from '@sdk/api/utils/getErrorForToast';
import useToast from '@sdk/common/toast/useToast';
import { CreateConversationPayload } from '@sdk/messages/types/apiTypes';
import { RestrictionType } from '@sdk/messages/types/RestrictionType';

import { useNavigate } from '@web/Router/router.hooks';
import { useCreateConversation } from '@web/conversations/hooks/useCreateConversation';

// @FIXME useToast is not a hook, then it returns new fn instances every call
// this cause endless loop when used in react as a hook dependency
// eslint-disable-next-line
const { showErrorToast } = useToast();

// userIdParam is comma separated list of IDs, e.g. userId=1 or userId=1,2,666
// if it's single ID, we want to create private conversation, otherwise it's got to be a group one
const createPayload = (userIdParam: string): CreateConversationPayload => {
  const idsArray = userIdParam.split(',');

  if (idsArray.length === 1) {
    return {
      members: [Number(idsArray[0])],
    };
  }

  return {
    name: '',
    personas: idsArray.map((id) => Number(id)),
    restricted: RestrictionType.NONE,
    restrictedToPersonas: [],
  };
};

export const StartConversation = () => {
  const [searchParams] = useSearchParams();
  const { mutate } = useCreateConversation();
  const navigate = useNavigate();
  const userIdParam = searchParams.get('userId');

  useEffect(() => {
    const payload = createPayload(userIdParam);

    mutate(payload, {
      onSuccess: ({ id, slug }) => {
        navigate.toConversationDetails({
          params: { id, slug },
        });
      },
      onError: (error) => {
        const errorMsg = getErrorForToast(error);
        showErrorToast(errorMsg);
      },
    });
  }, [mutate, navigate, userIdParam]);

  return null;
};
